/** Fixed glass tab bar. Content is never covered: .app-page reserves its height + safe area. */
import type { ComponentType, SVGProps } from 'react';
import { NavLink } from 'react-router';
import { Icon } from '@astryxdesign/core/Icon';

export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  end?: boolean;
}

export function BottomNav({ items, label }: { items: NavItem[]; label: string }) {
  return (
    <nav className="bottom-nav" aria-label={label}>
      <ul className="bottom-nav__list">
        {items.map((it) => (
          <li key={it.to}>
            <NavLink to={it.to} end={it.end} className="bottom-nav__link">
              <Icon icon={it.icon} size="md" />
              <span>{it.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
